import React from "react";
import { Link } from "react-router-dom";

function ProfileHeader({ name, email, onEditProfileClick }) {
  const initial = (name !== "—" ? name : "U").charAt(0).toUpperCase();
  const buttonClass =
    "btn btn-primary btn-sm d-inline-flex align-items-center gap-2";

  return (
    <div className="profile-header text-center text-md-start mb-4 pb-4 border-bottom">
      <div className="d-flex flex-column flex-md-row align-items-center gap-4">
        <div
          className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center fw-bold flex-shrink-0"
          style={{ width: 96, height: 96, fontSize: "2.5rem" }}
        >
          {initial}
        </div>
        <div className="flex-grow-1 gap-0">
          <h4 className="fw-bold mb-1 text-dark">{name}</h4>
          <p className="text-muted mb-3">{email ?? "—"}</p>
          {onEditProfileClick ? (
            <button
              type="button"
              className={buttonClass}
              onClick={onEditProfileClick}
            >
              <i className="bi bi-pencil" />
              Edit profile &amp; password
            </button>
          ) : (
            <Link to="/account" className={buttonClass}>
              <i className="bi bi-pencil" />
              Edit profile &amp; password
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProfileHeader;
